import moment from 'moment';
import {DATETIME_FORMAT} from './date.model';

export class PosModel {
  country: string;
  posData: PosDataModel[];
}

export class PosDataModel {
  ts: string;
  operator: string;
  ecPos: number;
  phPos: number;

  constructor(objIn: any) {
    this.ts = objIn.timestamp
      ? moment.utc(objIn.timestamp).local().format(DATETIME_FORMAT)
      : '';
    this.operator = objIn.operator.toLowerCase() || '';
    this.ecPos = objIn.economic_position || null;
    this.phPos = objIn.physical_position || null;
  }
}
